import axios from "axios"
import { toast } from 'react-toastify'
const UploadFile = async (e) =>{
    document.querySelector(".form-loader").classList.add("show")
    const files = e.target.files || []
    if(files && files.length > 0) {
        const formData = new FormData();
        formData.append("file", files[0])
        const URL = `${process.env.REACT_APP_JOURNEY_URL}/images`;
        const reqHeaders = {
        headers: {
            "Content-Type": "multipart/form-data",
        },
        };
        try{
            const response = await axios.post(URL, formData, reqHeaders);
            const uploadDocRes = response.data[0];
            if(response.status == 200 && uploadDocRes){
                toast.success('Image upload successfully!')
                return uploadDocRes
            }
        }catch(error){    
            if(error){
                toast.error("Image upload error")
                return false
            }
        }finally{
            document.querySelector(".form-loader").classList.remove("show")
        }
    }
}

export default UploadFile;